// frontend/src/components/TradeHistory.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadTrades } from '../redux/slices/tradingSlice';

const TradeHistory = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { trades } = useSelector((state) => state.trading);
  const [statusFilter, setStatusFilter] = useState('all');

  useEffect(() => {
    if (user?.uid) {
      dispatch(loadTrades(user.uid, statusFilter));
    }
  }, [user, statusFilter]);

  if (trades.length === 0) {
    return (
      <div className="card">
        <div className="card-header">
          <h2>Trade History</h2>
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="all">All Trades</option>
            <option value="OPEN">Open</option>
            <option value="CLOSED">Closed</option>
          </select>
        </div>
        <p className="text-muted">No trades yet</p>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header">
        <h2>Trade History</h2>
        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="all">All Trades</option>
          <option value="OPEN">Open</option>
          <option value="CLOSED">Closed</option>
        </select>
      </div>
      <div className="trades-table">
        <table>
          <thead>
            <tr>
              <th>Time</th>
              <th>Symbol</th>
              <th>Type</th>
              <th>Entry</th>
              <th>Exit</th>
              <th>Volume</th>
              <th>Profit</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {trades.map(trade => (
              <tr key={trade.id}>
                <td>{new Date(trade.openTime).toLocaleString()}</td>
                <td>{trade.symbol}</td>
                <td className={trade.type === 'BUY' ? 'buy-text' : 'sell-text'}>{trade.type}</td>
                <td>{trade.entryPrice?.toFixed(5)}</td>
                <td>{trade.exitPrice?.toFixed(5) || '-'}</td>
                <td>{trade.volume}</td>
                <td className={trade.profit >= 0 ? 'profit' : 'loss'}>
                  {trade.profit ? `$${trade.profit.toFixed(2)}` : '-'}
                </td>
                <td>
                  <span className={`status-badge ${trade.status}`}>
                    {trade.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TradeHistory;